// See templates.json for configuration options

import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import PersonIcon from '@material-ui/icons/Person'
import { Amplify } from 'aws-amplify'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LAYOUT_DRAWER_TABS_TOOLS_LOGIN_EXPANDED } from 'api/actions'
import * as Model from 'api/model'
import AuthAWSReact from 'aws/auth-react'
import AccordionWrapper from 'drawer/tabs/AccordionWrapper'
import PoziDrawerTabToolsLogin from 'drawer/tabs/tools/login'
import Upgrade from 'drawer/tabs/Upgrade'

const styles = theme => ({
  root: {},
  rootDetails: {
    paddingRight: 4,
    paddingLeft: 4,
    paddingTop: 0,
    paddingBottom: 0
  },
  notlicensed: {
    padding: 20
  },
  localResourceText: {
    padding: 20
  }
})

class ToolsPanelLogin extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeStep: 0
    }
    const { classes, title } = props
    this.pure = {}
    this.pure.title = title
    this.pure.headerIcon = <PersonIcon />

    this.pure.upgradeText = Model.get('config.layout.drawer.tabs.tools.login.upgrade.text', 'Upgrade to Pozi Enterprise')
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.login.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.login.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />

    this.pure.localResourceMarkup = <Typography className={classes.localResourceText} variant="body2">Local resource access is enabled.</Typography>

    this.pure.amplifyConfig = Model.get('config.layout.drawer.tabs.tools.login.amplify', null)
    if (isNil(this.pure.amplifyConfig)) {
      return
    }
    if (!this.pure.amplifyConfig.Analytics) {
      this.pure.amplifyConfig.Analytics = {
        autoSessionRecord: false
      }
    }

    const bConfigInState = Model.getState('config')
    if (bConfigInState) {
      console.log('Skipping Amplify.configure for toolspanellogin.js due to config flag')
      Amplify.configure(this.pure.amplifyConfig)
    } else {
      console.log('Amplify.configure toolspanellogin.js', this.pure.amplifyConfig)
      this.pure.authAWSReact = <AuthAWSReact />
    }
  }

  componentDidUpdate (prevProps) {
    const { expanded } = this.props
    if (expanded !== prevProps.expanded && expanded) {
      PoziDrawerTabToolsLogin().init()
    }
  }

  render () {
    const { classes, enabled, expanded, toggleExpansionPanel } = this.props

    let markup = null
    let licensed = true
    if (!enabled) {
      if (Model.get('app.LocalDataSourceDetected', false)) {
        markup = this.pure.localResourceMarkup
      } else {
        licensed = false
        markup = this.pure.upgradeMarkup
      }
    } else if (!isNil(this.pure.amplifyConfig) && expanded) {
      markup = (<div>
        {this.pure.authAWSReact}
      </div>
      )
    } else {
      markup = this.pure.upgradeMarkup
    }

    // Don't show login option if customer isn't licensed for it
    if (!licensed) {
      return null
    }

    return (
      <div className={classes.root}>
        <AccordionWrapper
          expanded={expanded}
          licensed={licensed}
          onChange={toggleExpansionPanel}
          headerIcon={this.pure.headerIcon}
          title={this.pure.title}
          bExcludeExpandIcon={false}
        >
          <div className={classes.rootDetails}>
            {markup}
          </div>
        </AccordionWrapper>
      </div>
    )
  }
}

ToolsPanelLogin.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpansionPanel: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  const enabled = get(state, 'config.layout.drawer.tabs.tools.login.visible', false) // See templates.json
  const title = get(state, 'config.layout.drawer.tabs.tools.login.title', 'Login') // See templates.json
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_TOOLS_LOGIN_EXPANDED, false)
  return {
    enabled,
    title,
    expanded
  }
}

const mapDispatchToProps = dispatch => {
  return {

  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ToolsPanelLogin)
  )
)
